import { render, staticRenderFns } from "./OtherData.vue?vue&type=template&id=65afb7c8&scoped=true"
import script from "./OtherData.vue?vue&type=script&lang=js"
export * from "./OtherData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65afb7c8",
  null
  
)

export default component.exports